import DropdownComponent from "./dropdown/dropdown.component";
import { DICT_ARIA_RESOURCE_TEXT, DICT_DEFAULT_RESOURCE_TEXT, LOCATION_EVENTS } from "../utils/constants";
import SectionComponent from "./section.component";

export default class LocationComponent extends SectionComponent {

    #resourcesService = null;
    #locationDropdown = null;
    #locationData = [];

    get locationDetailsElement() {
        //Contains address & Contact info
        return this.querySelector('#v24LocationDetailsDiv');
    }

    #shouldUseTypeahead(options) {
        return options.length > this.minNumberOfOptions && this.minNumberOfOptions != -1;
    }

    constructor() {
        super();
    }

    init(_resourcesService) {
        this.#resourcesService = _resourcesService;
    }

    setLocationData(locationData) {

        this.clearContent();

        this.#locationData = locationData;

        if (this.#locationData?.length > 0) {

            if (this.#locationData.length > 1) {

                this.minNumberOfOptions = this.#resourcesService.getResource("SELFSCHEDULER_LOCATIONS_TYPEAHEAD_MIN_LIMIT", 5);

                this.createDropdownInstructions();
                this.createDropdown(this.#locationData);

            } else {
                const singleLocation = this.#locationData[0];
                if (singleLocation) {
  
                    const confirmSelectedLocation = document.createElement("p");
                    confirmSelectedLocation.innerHTML = this.#resourcesService.getResource("SELFSCHEDULER_CONFIRM_LOCATION", "Confirm selected location:");
                    super.appendChild(confirmSelectedLocation);

                    this.#setSelectedLocation(singleLocation);
                }
            }

        }
    }

    createDropdownInstructions() {
        let instructionsText = this.#resourcesService.getResource("SELFSCHEDULER_LOCATIONPAGEINSTRUCTIONS", DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_LOCATIONPAGEINSTRUCTIONS);
        this.setInstructions(this.instructions.innerHTML + `<p aria-label="${instructionsText}">${instructionsText}</p>`);
    }

    createDropdown(data) {
        const placeholder = this.#resourcesService.getResource("SELFSCHEDULER_DEFAULTSELECTOPTION", DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_DEFAULTSELECTOPTION);
        const sortById = this.#resourcesService.getResource("SELFSCHEDULER_DROPDOWN_SORTBYID", "0") === "1";

        this.#locationDropdown = new DropdownComponent({
            className: "v24-select",
            id: `v24-location-select`,
            style: "margin:auto; !important",
            level: "1",
            placeholder,
            sortById
        });
        this.#locationDropdown.setOptions(data, this.#shouldUseTypeahead(data));
        super.appendChild(this.#locationDropdown);

        this.#locationDropdown.addEventListener("dropdown-change", this.onLocationSelected.bind(this));
    }

    onLocationSelected(e) {
        const dropdownEl = e.currentTarget;
        const selectedId = dropdownEl.dataset.selectedId;
        const locationInfo = this.#locationData.find(item => item.id == parseInt(selectedId));
       
        this.#setSelectedLocation(locationInfo);
    }

    #setSelectedLocation(location) {
        this.dispatchEvent(new CustomEvent(LOCATION_EVENTS.locationSelected, {
            detail: {
                location,
            }
        }));
    }

    createAddressDetails(location) {
        if (location) {

            if (this.locationDetailsElement) {
                this.locationDetailsElement.remove();
            }

            const address = document.createElement("address");
            address.id = "v24LocationDetailsDiv";
            address.className = "v24-location-details";
            const addressLine2Row = (location.addressLine2 !== undefined && location.addressLine2 !== null && location.addressLine2.length > 0) ? location.addressLine2 + '<br/>': '';
            address.innerHTML = `   ${location.address}<br/>
                                    ${addressLine2Row}
                                    ${location.country}<br/>
                                    ${location.postcode}<br/>
                                    ${this.#createEmailHTML(location.contactEmail)}
                                    ${this.#createPhoneHTML(location.phone)}
                                `;

            super.appendChild(address);
        }
    }

    #createPhoneHTML(phoneNumber) {
        if (phoneNumber.length > 0) {
            let ariaLabel = this.#resourcesService.getResource("SELFSCHEDULER_ARIA_PHONE_NUMBER",DICT_ARIA_RESOURCE_TEXT.SELFSCHEDULER_ARIA_PHONE_NUMBER);
            return `<a aria-label="${ariaLabel} ${phoneNumber}" href="tel:${phoneNumber}">${phoneNumber}</a><br/>`
        }
        else return "";
    }

    #createEmailHTML(emailAddress) {
        if (emailAddress.length > 0) {
            let ariaLabel = this.#resourcesService.getResource("SELFSCHEDULER_ARIA_EMAIL_ADDRESS",DICT_ARIA_RESOURCE_TEXT.SELFSCHEDULER_ARIA_EMAIL_ADDRESS);
            return `<a aria-label="${ariaLabel} ${emailAddress}" href="mailto:${emailAddress}">${emailAddress}</a><br/>`
        }
        else return "";
    }

    clearContent() {
        this.setContent("");
    }

    disconnectedCallback() {
        this.clearContent();
    }
}